<template>
  <div class="e-form-tab tabs">
    <span
      v-for="{id, name} in showedTabs"
      :key="id"
      @click="setTab(id)"
      :class="{'active': id === value}"
    >
      {{$translate(name)}}
    </span>
  </div>
</template>

<script>
  import url from '../../utils/url.js'

  export default {
    name: "e-form-tabs",
    props: {
      value: {
        type: String,
        default: 'tab1'
      },
      tabs: {
        type: Array,
        default: () => ([
          {tab1: 'Общие сведения'}
        ])
      }
    },
    computed: {
      showedTabs () {
        return this.tabs.map(obj => {
          let key = Object.keys(obj)[0]
          return {
            id: key,
            name: obj[key]
          }
        })
      }
    },
    created () {
      if (this.$route.query.tabView) {
        this.setTab(this.$route.query.tabView)
      }
    },
    watch: {
      '$route': function () {
        if (this.$route.query.tabView) {
          this.setTab(this.$route.query.tabView)
        }
      },
      'value': function () {
        let route = url.getRoute(this.$route)
        if (this.value) {
          route.query.tabView = this.value
        } else {
          delete route.query.tabView
        }
        this.$router.replace(route)
      }
    },
    methods: {
      setTab (val) {
        this.$emit('input', val)
      }
    }
  }
</script>
